import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useLang, useCart } from "../context";
import { t } from "../content";
import { http } from "../api";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function ProductDetail() {
  const { id } = useParams();
  const { lang } = useLang();
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [p, setP] = useState(null);
  const [activeImg, setActiveImg] = useState(0);

  useEffect(() => { http.get(`/products/${id}`).then((r) => { setP(r.data); setActiveImg(0); }).catch(() => setP(false)); }, [id]);

  if (p === false) return <div className="max-w-7xl mx-auto px-6 py-32 text-center serif text-2xl">404</div>;
  if (!p) return <div className="max-w-7xl mx-auto px-6 py-32" />;

  const imgs = p.images && p.images.length ? p.images : [p.image];
  const add = () => { addToCart(p); toast.success(lang === "fr" ? "Ajouté au panier" : "Added to cart"); };

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-8">
      <button onClick={() => navigate(-1)} data-testid="back-btn" className="inline-flex items-center gap-2 text-sm text-[#737373] hover:text-[#1A1A1A] mb-6">
        <ArrowLeft size={16} strokeWidth={1.5} /> {t.product.back[lang]}
      </button>
      <div className="grid lg:grid-cols-2 gap-12">
        <div className="lg:sticky lg:top-24 self-start">
          <div className="bg-[#F0EBE1] aspect-[3/4] relative">
            <img src={imgs[activeImg]} alt={p[`name_${lang}`]} className="w-full h-full object-contain" />
            {p.is_unique && <span className="absolute top-4 left-4 bg-[#1A1A1A] text-[#F9F8F6] text-[10px] uppercase tracking-widest px-2 py-1">{t.product.unique[lang]}</span>}
          </div>
          {imgs.length > 1 && (
            <div className="flex gap-3 mt-3">
              {imgs.map((src, i) => (
                <button key={src} onClick={() => setActiveImg(i)} data-testid={`thumb-${i}`}
                  className={`w-20 h-24 bg-[#F0EBE1] overflow-hidden border ${activeImg === i ? "border-[#1A1A1A]" : "border-transparent"}`}>
                  <img src={src} alt="" className="w-full h-full object-contain" />
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="lg:py-4">
          <h1 className="serif text-4xl lg:text-5xl leading-tight">{p[`name_${lang}`]}{p.size ? ` - ${p.size}` : ""}</h1>
          <p className="text-xl text-[#404040] mt-4">{p.price.toFixed(2)} $ CAD</p>
          <p className="mt-6 text-base text-[#404040] leading-relaxed">{p[`desc_${lang}`]}</p>

          <button onClick={add} data-testid="add-to-cart-btn"
            className="mt-8 w-full bg-[#1A1A1A] text-[#F9F8F6] py-4 text-sm uppercase tracking-widest rounded-sm hover:opacity-90 transition-opacity">
            {t.product.add[lang]}
          </button>

          <Link to="/faq" className="co-link inline-block mt-8 text-sm uppercase tracking-widest text-[#737373]">{lang === "fr" ? "Livraison & retours" : "Shipping & returns"}</Link>
        </div>
      </div>
    </div>
  );
}
